import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview as PeopleOverview } from 'domains/Organizations/Organization/TeamManagement'
import {
  organizationTabsOverviewLayoutRoute,
  organizationRoute,
} from 'pages/NWPlatform/Organizations/Organization/Routing'

export const teamsRoute = createRoute({
  getParentRoute: () => organizationRoute,
  path: StaticRouteParameter.TEAMS,
  loader: () => ({
    crumb: t('entity:org.team', { count: 2 }),
  }),
})

type TeamsOverviewSearch = {
  query?: string
}

export const teamsOverviewRoute = createRoute({
  getParentRoute: () => organizationTabsOverviewLayoutRoute,
  path: `${StaticRouteParameter.TEAMS}/`,
  component: PeopleOverview,
  validateSearch: (search: Record<string, unknown>): TeamsOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
